import React from 'react';

const Icon = ({type, className, ...props}) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke='currentColor'
        className={className}
        {...props}
    >
        {type}
    </svg>
);

export default Icon;
